"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SentenceResult = void 0;
var mathjs_1 = require("mathjs");
var filter_nulls_1 = __importDefault(require("../utils/filter_nulls"));
var SentenceResult = /** @class */ (function () {
    function SentenceResult() {
        this.sentences = [];
        this.responses = [];
        this.expectedResponses = [];
        this.readingTimes = [];
        this.averageRTMillis = 0;
        this.numberCorrect = 0;
        this.speedErrors = 0;
    }
    SentenceResult.prototype.addInput = function (sentence, response, expectedResponse, readTimeMillis) {
        this.sentences.push(sentence);
        this.responses.push(response);
        this.expectedResponses.push(expectedResponse);
        this.readingTimes.push(readTimeMillis);
        if (response === null)
            this.speedErrors++;
        if (response === expectedResponse) {
            this.numberCorrect++;
        }
        else {
            console.debug("You got this one wrong");
            console.debug(sentence);
        }
        if (this.averageRTMillis === 0 && readTimeMillis !== null) {
            this.averageRTMillis = readTimeMillis;
        }
        else if (readTimeMillis !== null) {
            this.averageRTMillis = (this.averageRTMillis + readTimeMillis) / 2;
        }
    };
    SentenceResult.prototype.percentCorrect = function () {
        console.debug("numberCorrect: " + this.numberCorrect);
        console.debug("total sentences: " + this.sentences.length);
        return (this.numberCorrect / this.sentences.length) * 100;
    };
    SentenceResult.prototype.meanReadTime = function () {
        var sum = 0;
        for (var i = 0; i < this.readingTimes.length; i++) {
            var readingTime = this.readingTimes[i];
            if (readingTime === null)
                continue;
            sum += readingTime;
        }
        return sum / this.readingTimes.length;
    };
    SentenceResult.prototype.maxReadingTime = function () {
        var stdDeviation = Number((0, mathjs_1.format)((0, mathjs_1.std)((0, filter_nulls_1.default)(this.readingTimes), "unbiased")));
        console.debug("[SENTENCE_PRACTICE][SENTENCE_MAX] - AVERAGE READING TIME = ".concat(this.meanReadTime()));
        console.debug("[SENTENCE_PRACTICE][SENTENCE_MAX] - STANDARD DEVIATION = ".concat(stdDeviation));
        // The max reading time is defined as 2.5 times the standard deviation of the reading times.
        return this.meanReadTime() + 2.5 * stdDeviation;
    };
    return SentenceResult;
}());
exports.SentenceResult = SentenceResult;
